import { CommonModule } from '@angular/common';
import { importProvidersFrom, ModuleWithProviders, NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';

import {
  AsideModule,
  ButtonComponent,
  CalibrationModule,
  CanvasModule,
  CheckboxComponent,
  CheckboxTwoValuesComponent,
  ColorModule,
  ComponentsModule,
  FrameModule,
  InputComponent,
  NumericFieldComponent,
  ReadingModule,
  ReleaseNotesModule,
  RibbonModule,
  SelectComponent,
  ToggleComponent,
} from '@olympus/ngx-shared';
import { FormControlComponent, IconButtonComponent } from 'shared-components/desktop';
import { KeyboardShortcutDirective } from 'shared-components/handle-keyboard-shortcut';
import { IconComponent } from 'shared-components/icon';

@NgModule({
  imports: [
    // Angular modules
    CommonModule,
    FormsModule,
    RouterModule,

    // Internal modules
    AsideModule,
    CalibrationModule,
    ColorModule,
    FrameModule,
    ReleaseNotesModule,

    // Internal modules with providers
    CanvasModule.forChild(),
    ComponentsModule.forChild(),
    ReadingModule.forChild(),
    RibbonModule.forChild(),

    // Standalone components
    InputComponent,
    ButtonComponent,
    CheckboxComponent,
    CheckboxTwoValuesComponent,
    ToggleComponent,
    NumericFieldComponent,
    SelectComponent,

    // From shared-components
    IconComponent,
    FormControlComponent,
    IconButtonComponent,
    KeyboardShortcutDirective,
  ],
  exports: [
    // Angular modules
    CommonModule,
    FormsModule,
    RouterModule,

    // Internal modules
    AsideModule,
    CalibrationModule,
    ColorModule,
    FrameModule,
    ReleaseNotesModule,

    // Internal modules with providers
    CanvasModule,
    ComponentsModule,
    ReadingModule,
    RibbonModule,

    // Standalone components
    ButtonComponent,
    CheckboxComponent,
    CheckboxTwoValuesComponent,
    InputComponent,
    NumericFieldComponent,
    SelectComponent,
    ToggleComponent,

    // From shared-components
    IconButtonComponent,
    KeyboardShortcutDirective,
  ],
})
export class SharedModule {
  public static forRoot(): ModuleWithProviders<SharedModule> {
    return {
      ngModule: SharedModule,
      providers: [
        importProvidersFrom(
          CanvasModule.forRoot(),
          ComponentsModule.forRoot(),
          ReadingModule.forRoot(),
          RibbonModule.forRoot(),
        ),
      ],
    };
  }

  public static forChild(): ModuleWithProviders<SharedModule> {
    return {
      ngModule: SharedModule,
    };
  }
}
